export enum SearchColumn {
  DEPARTURE_ID = 'DEPARTURE_ID',

  DATE_DETERMINED = 'DATE_DETERMINED',
  DATE_RECEIVED_AT_HE = 'DATE_RECEIVED_AT_HE',
  DATE_PREVIOUS_STAGE_COMPLETED = 'DATE_PREVIOUS_STAGE_COMPLETED',
  TIME_IN_WORKFLOW_STATE = 'TIME_IN_WORKFLOW_STATE',
  NUMBER_OF_LOCATIONS = 'NUMBER_OF_LOCATIONS',
  STRUCTURE_KEYS = 'STRUCTURE_KEYS',
  ALL_STRUCTURE_KEYS = 'ALL_STRUCTURE_KEYS',
  TIME_ENTERED_SES = 'TIME_ENTERED_SES',
  TIME_LEFT_SES = 'TIME_LEFT_SES',

  TIME_IN_NEED_IDENTIFIED = 'TIME_IN_NEED_IDENTIFIED',
  TIME_IN_SUBMISSION_IN_PREPARATION = 'TIME_IN_SUBMISSION_IN_PREPARATION',
  TIME_IN_PM_APPRAISAL = 'TIME_IN_PM_APPRAISAL',
  TIME_IN_PM_APPRAISAL_REWORK = 'TIME_IN_PM_APPRAISAL_REWORK',
  TIME_IN_DAS_ADMIN = 'TIME_IN_DAS_ADMIN',
  TIME_IN_DAS_ADMIN_REWORK = 'TIME_IN_DAS_ADMIN_REWORK',
  TIME_IN_SPECIALIST_SUBMISSION_POINT = 'TIME_IN_SPECIALIST_SUBMISSION_POINT',
  TIME_IN_SPECIALIST_SUBMISSION_POINT_REWORK = 'TIME_IN_SPECIALIST_SUBMISSION_POINT_REWORK',
  TIME_IN_SPECIALIST_REVIEW = 'TIME_IN_SPECIALIST_REVIEW',
  TIME_IN_REWORK_REQUIRED = 'TIME_IN_REWORK_REQUIRED',
  TIME_IN_PM_DETERMINATION = 'TIME_IN_PM_DETERMINATION',
  TIME_IN_APPROVED = 'TIME_IN_APPROVED',
  TIME_IN_APPROVED_WITH_CONDITIONS = 'TIME_IN_APPROVED_WITH_CONDITIONS',
  TIME_IN_REJECTED = 'TIME_IN_REJECTED',
  TIME_IN_WITHDRAWN = 'TIME_IN_WITHDRAWN',
  TIME_IN_SES = 'TIME_IN_SES',
  TIME_OPEN = 'TIME_OPEN',
  TIME_REMAINING_IN_SES = 'TIME_REMAINING_IN_SES',

  DATE_PROVISIONAL_AGREEMENT_REQUESTED = 'DATE_PROVISIONAL_AGREEMENT_REQUESTED',
  DATE_PROVISIONAL_AGREEMENT_REVIEWED = 'DATE_PROVISIONAL_AGREEMENT_REVIEWED',

  CONFIDENTIAL = 'CONFIDENTIAL',
  PROVISIONAL_AGREEMENT = 'PROVISIONAL_AGREEMENT',
  INNOVATION = 'INNOVATION',
  YEAR_OF_ISSUE = 'YEAR_OF_ISSUE',
  ADDED_VALUE = 'ADDED_VALUE',
  CLAUSE_PARAGRAPH = 'CLAUSE_PARAGRAPH',
  DEPARTURE_SUMMARY = 'DEPARTURE_SUMMARY',
  DESIGN_ORGANISATION = 'DESIGN_ORGANISATION',
  DESIGN_ORGANISATION_ID = 'DESIGN_ORGANISATION_ID',
  PIN = 'PIN',
  STANDARD = 'STANDARD',
  TITLE = 'TITLE',
  ROAD = 'ROAD',
  SCHEME_NAME = 'SCHEME_NAME',
  FORM_OF_CONTRACT = 'FORM_OF_CONTRACT',
  OPERATION_OR_MAJOR_PROJECT_DIVISION = 'OPERATION_OR_MAJOR_PROJECT_DIVISION',
  TEMPLATE = 'TEMPLATE',
  DEPARTURE_CRITICALITY = 'DEPARTURE_CRITICALITY',
  PROJECT_SAFETY_RISK = 'PROJECT_SAFETY_RISK',
  DEPARTURE_SAFETY_RISK = 'DEPARTURE_SAFETY_RISK',
  REVISION = 'REVISION',
  DEPARTURE_ID_NUMBER = 'DEPARTURE_ID_NUMBER',
  DEPARTURE_ID_NUMBER_AND_REVISION = 'DEPARTURE_ID_NUMBER_AND_REVISION',
  CATEGORY = 'CATEGORY',
  SUBJECT = 'SUBJECT',
  DESCRIPTION = 'DESCRIPTION',
  VOLUME = 'VOLUME',

  ADDITIONAL_TECHNICAL_REVIEWERS_UUIDS = 'ADDITIONAL_TECHNICAL_REVIEWERS_UUIDS',
  DESIGNERS_UUIDS = 'DESIGNERS_UUIDS',
  CURRENT_AND_PREVIOUS_PROJECT_MANAGER_UUIDS = 'CURRENT_AND_PREVIOUS_PROJECT_MANAGER_UUIDS',

  ASSIGNEE_UUID = 'ASSIGNEE_UUID',
  AUTHORISING_SIGNATORY_UUID = 'AUTHORISING_SIGNATORY_UUID',
  PROJECT_MANAGER_UUID = 'PROJECT_MANAGER_UUID',
  PROPOSER_UUID = 'PROPOSER_UUID',
  SSP_UUID = 'SSP_UUID',
  TECHNICAL_SPECIALIST_UUID = 'TECHNICAL_SPECIALIST_UUID',

  ADDITIONAL_TECHNICAL_REVIEWERS_NAMES = 'ADDITIONAL_TECHNICAL_REVIEWERS_NAMES',
  DESIGNERS_NAMES = 'DESIGNERS_NAMES',
  CURRENT_AND_PREVIOUS_PROJECT_MANAGER_NAMES = 'CURRENT_AND_PREVIOUS_PROJECT_MANAGER_NAMES',

  ASSIGNEE_NAME = 'ASSIGNEE_NAME',
  AUTHORISING_SIGNATORY_NAME = 'AUTHORISING_SIGNATORY_NAME',
  PROJECT_MANAGER_NAME = 'PROJECT_MANAGER_NAME',
  PROPOSER_NAME = 'PROPOSER_NAME',
  SSP_NAME = 'SSP_NAME',
  TECHNICAL_SPECIALIST_NAME = 'TECHNICAL_SPECIALIST_NAME',

  WORK_FLOW_STATE = 'WORK_FLOW_STATE',
  PM_TO_VIEW_POST_RECOMMENDATION = 'PM_TO_VIEW_POST_RECOMMENDATION',

  ALL_REASON_CODES = 'ALL_REASON_CODES',
  LATEST_REASON_CODES = 'LATEST_REASON_CODES',

  DAS_2_BULK_DEPARTURE = 'DAS_2_BULK_DEPARTURE',
  DAS_2_PARENT_DEPARTURE_ID = 'DAS_2_PARENT_DEPARTURE_ID',
  DAS_2_STATUS = 'DAS_2_STATUS',
  DAS_2_REFERENCE_TYPE = 'DAS_2_REFERENCE_TYPE',
  DAS_2_DEALING_OFFICER = 'DAS_2_DEALING_OFFICER',
  DAS_2_AUTHORISING_OFFICER = 'DAS_2_AUTHORISING_OFFICER',
  DAS_2_TENDERER_DESIGNER = 'DAS_2_TENDERER_DESIGNER',
  DAS_2_DATE_ENTERED = 'DAS_2_DATE_ENTERED',
  DAS_2_DECISION_SUMMARY = 'DAS_2_DECISION_SUMMARY',

  REALISED_ADDED_VALUE = 'REALISED_ADDED_VALUE',
  NUMBER_OF_LOCATIONS_INCORPORATED = 'NUMBER_OF_LOCATIONS_INCORPORATED',
  NUMBER_OF_LOCATIONS_NOT_INCORPORATED = 'NUMBER_OF_LOCATIONS_NOT_INCORPORATED',
  NUMBER_OF_LOCATIONS_TO_BE_CONFIRMED = 'NUMBER_OF_LOCATIONS_TO_BE_CONFIRMED',
  NUMBER_OF_LOCATIONS_INCORPORATED_AND_DATE_PROVIDED = 'NUMBER_OF_LOCATIONS_INCORPORATED_AND_DATE_PROVIDED',
  NUMBER_OF_LOCATIONS_WITH_STATUS_WILL_NOT_BE_CONFIRMED = 'NUMBER_OF_LOCATIONS_WITH_STATUS_WILL_NOT_BE_CONFIRMED',
  NUMBER_OF_LOCATIONS_WITH_POST_DETERMINATION_ACTIONS_REMAINING = 'NUMBER_OF_LOCATIONS_WITH_POST_DETERMINATION_ACTIONS_REMAINING',
  ALL_LOCATION_POST_DETERMINATION_ACTIONS_COMPLETE = 'ALL_LOCATION_POST_DETERMINATION_ACTIONS_COMPLETE',

  NUMBER_OF_CONDITIONS = 'NUMBER_OF_CONDITIONS',
  NUMBER_OF_CONDITIONS_TO_BE_CONFIRMED = 'NUMBER_OF_CONDITIONS_TO_BE_CONFIRMED',
  NUMBER_OF_CONDITIONS_ADHERED_TO = 'NUMBER_OF_CONDITIONS_ADHERED_TO',
  NUMBER_OF_CONDITIONS_NOT_ADHERED_TO = 'NUMBER_OF_CONDITIONS_NOT_ADHERED_TO',
  NUMBER_OF_CONDITIONS_PARTIALLY_ADHERED_TO = 'NUMBER_OF_CONDITIONS_PARTIALLY_ADHERED_TO',
  NUMBER_OF_CONDITIONS_WITH_STATUS_WILL_NOT_BE_CONFIRMED = 'NUMBER_OF_CONDITIONS_WITH_STATUS_WILL_NOT_BE_CONFIRMED',
  NUMBER_OF_CONDITIONS_WITHOUT_COMMENT_PROVIDED = 'NUMBER_OF_CONDITIONS_WITHOUT_COMMENT_PROVIDED',
  NUMBER_OF_CONDITIONS_WITH_POST_DETERMINATION_ACTIONS_REMAINING = 'NUMBER_OF_CONDITIONS_WITH_POST_DETERMINATION_ACTIONS_REMAINING',
  ALL_CONDITIONS_ADHERED_TO = 'ALL_CONDITIONS_ADHERED_TO',
  ALL_CONDITION_POST_DETERMINATION_ACTIONS_COMPLETE = 'ALL_CONDITION_POST_DETERMINATION_ACTIONS_COMPLETE',

  ALL_POST_DETERMINATION_ACTIONS_COMPLETE = 'ALL_POST_DETERMINATION_ACTIONS_COMPLETE',

  PM_LIAISED = 'PM_LIAISED',

  NUMBER_OF_LINKED_DEPARTURES = 'NUMBER_OF_LINKED_DEPARTURES',
  LINKED_SIMILAR_DEPARTURE_IDS = 'LINKED_SIMILAR_DEPARTURE_IDS',
  LINKED_REPEAT_DEPARTURE_IDS = 'LINKED_REPEAT_DEPARTURE_IDS',
  LINKED_ASSOCIATED_DEPARTURE_IDS = 'LINKED_ASSOCIATED_DEPARTURE_IDS',
}
